import { useMemo } from 'react';

import useModularPDPState from '../useModularPDPState';
import useProductBasicDetails from '../useProductBasicDetails';

const useModularPDPAvailableSizes = (id, slug) => {
  const {
    data: basicDetails,
    loading: basicDetailsLoading,
  } = useProductBasicDetails();
  const {
    data: { modularState },
    loading,
  } = useModularPDPState(id, slug);

  const availableSizes = useMemo(() => {
    if (modularState?.preConfiguredProducts?.length || basicDetails?.id) {
      const availableSizesData = modularState?.preConfiguredProducts?.map(
        preConfigProduct => ({
          id: preConfigProduct.id,
          slug: preConfigProduct.slug,
        })
      );
      return availableSizesData;
    }
    return null;
  }, [basicDetails?.id, modularState?.preConfiguredProducts]);

  return {
    loading: loading || basicDetailsLoading,
    data: {
      id: basicDetails?.id,
      available_sizes: availableSizes,
    },
  };
};

export default useModularPDPAvailableSizes;
